import { relationImg, relationNodes } from "@/mocks/expose";

const statusStyle: Record<string, string> = {
  实锤: "bg-primary-100 text-primary-700",
  强关联: "bg-accent-100 text-accent-800",
  待验证: "bg-secondary-100 text-secondary-900",
  辟谣: "bg-background-200 text-foreground-500",
};

export default function RelationModule() {
  return (
    <section id="relations" className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
      <div className="grid items-start gap-6 lg:grid-cols-2">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <i className="ri-git-branch-line text-base"></i>
            Relationship · 隐藏关系网
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            表面上毫无交集，图谱里却是同一张网
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            同框、同机、同地址、同一天出资……我们把这些零散信号画进同一张关系网，
            隐藏关系会在交叉处自己浮出来。每条结论都标注验证状态，供读者自行复核，而非替你下判断。
          </p>

          {/* 克制配图，配一条横贯的图注 */}
          <figure className="mt-5 overflow-hidden rounded-lg border border-background-200/80">
            <div className="relative h-52 md:h-60">
              <img
                src={relationImg}
                alt="隐藏关系网可视化示意：节点与连线交织"
                title="隐藏关系 人物关系网 未公开信息"
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute left-3 top-3 rounded bg-foreground-950/70 px-2 py-1 text-[11px] font-medium text-background-50 backdrop-blur">
                关系网 · 示意图
              </span>
            </div>
            <figcaption className="flex items-center gap-2 border-t border-background-200/80 bg-background-50 px-4 py-3 text-xs text-foreground-500">
              <i className="ri-information-line text-accent-600"></i>
              节点连线仅基于公开信息生成，人名已用代号脱敏，点击节点可查看对应证据。
            </figcaption>
          </figure>
        </div>

        {/* 实证结论流 */}
        <div className="relative border-l-2 border-background-200 pl-5">
          <span className="absolute -left-[5px] top-1 flex h-2 w-2 items-center justify-center">
            <span className="h-2 w-2 rounded-full bg-accent-500"></span>
          </span>
          {relationNodes.map((n, i) => (
            <div
              key={n.title}
              className="relative mb-5 rounded-lg border border-background-200/80 bg-background-100 p-4 last:mb-0"
            >
              <span className="absolute -left-[21px] flex h-2 w-2 items-center justify-center">
                <span
                  className={`h-2 w-2 rounded-full ${
                    n.tag === "辟谣" ? "bg-foreground-400" : "bg-primary-500"
                  }`}
                ></span>
              </span>
              <div className="flex items-center justify-between gap-2">
                <span
                  className={`rounded px-2 py-0.5 text-[11px] font-semibold ${statusStyle[n.tag]}`}
                >
                  {n.tag}
                </span>
                <span className="font-heading text-sm font-bold text-secondary-300">
                  NODE {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-2 text-[15px] font-semibold leading-6 text-foreground-900">
                {n.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{n.meta}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}